import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { saveAddress } from '../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';

const MyLocation = () => {
    const token = useSelector((state) => state.user.token);
    const user_id = useSelector((state) => state.user.userId);
    const [location, setLocation] = useState('');
    const [address, setAddress] = useState('');
    const [tag, setTag] = useState('');
    const [coords, setCoords] = useState({ lat: null, lon: null });
    const [locationError, setLocationError] = useState(null);
    const location1 = useLocation();
    const { lat, lon } = location1.state || {}; // Get lat/lon from location state if available
    const navigation = useNavigate();

    useEffect(() => {
        // If lat/lon are provided, use those; otherwise, use the browser's geolocation
        if (lat !== undefined && lon !== undefined) {
            // Use the provided lat/lon
            setCoords({ lat, lon });
            fetchAddress(lat, lon);
        } else if (navigator.geolocation) {
            // Fetch current location using browser's geolocation
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setCoords({ lat: latitude, lon: longitude });
                    fetchAddress(latitude, longitude);
                },
                (error) => {
                    setLocationError("Unable to retrieve your location. Please check your GPS settings.");
                }
            );
        } else {
            setLocationError('Geolocation is not supported by your browser.');
        }
    }, [lat, lon]);

    const fetchAddress = (latitude, longitude) => {
        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`)
            .then((response) => response.json())
            .then((data) => {
                const address = data.display_name;
                setLocation(address);
            })
            .catch((error) => {
                setLocationError('Error fetching address.');
            });
    };

    const handleAddress = async () => {
        const formData = new FormData();
        formData.append("token", token);
        formData.append("user_id", user_id);
        formData.append("latitude", coords.lat);
        formData.append("longitude", coords.lon);
        formData.append("address", location);
        formData.append("house", address);
        formData.append("tag", tag);
        formData.append("get_only_default_address", "get_only_default_address");

        try {
            const response = await saveAddress(formData);
            //console.log("Address saved: ", response);
            setAddress(response);
            navigation("/");
        } catch (error) {
            console.error("Error saving address:", error);
        }
    };

    return (
        <div style={styles.container}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "96vh", width: "87%", margin: "auto" }}>
                <div style={styles.map}>
                    {coords.lat && coords.lon ? (
                        <iframe
                            title="map"
                            width="100%"
                            height="300px"
                            frameBorder="0"
                            src={`https://maps.google.com/maps?q=${coords.lat},${coords.lon}&z=15&output=embed`}
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <p>Map will be displayed here...</p>
                    )}
                </div>
                <div style={styles.locationDetails}>
                    <h3>Your Location</h3>
                    <div style={styles.locationRow}>
                        {locationError ? (
                            <p style={styles.error}>{locationError}</p>
                        ) : (
                            <p style={styles.locationText}>{location}</p>
                        )}
                        <button onClick={() => navigation(-1)} style={styles.gpsButton}>Change</button>
                    </div>
                    <h5 style={{ margin: "10px 0px" }}>Address</h5>
                    <input type="text" style={styles.input} value={address}
                        onChange={(e) => setAddress(e.target.value)} />
                    <h5 style={{ margin: "10px 0px" }}>Tag</h5>
                    <input type="text" placeholder='EG. HOME WORK' style={styles.input} 
                        value={tag}
                        onChange={(e) => setTag(e.target.value)} />
                </div>
            </div>
            <button style={styles.saveButton} onClick={handleAddress}>Save Address</button>
        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial', width: "100%", height: "98vh" },
    map: { width: '100%', height: '300px', backgroundColor: '#e0e0e0', marginBottom: '16px', display: 'flex' },
    locationDetails: { padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '8px' },
    locationRow: { display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" },
    gpsButton: {
        padding: '8px 16px', border: 'none', cursor: 'pointer', color: "orangered",
        border: "1px solid #c3bdbd",
    },
    input: { width: '100%', padding: '8px', fontSize: '16px', marginBottom: '16px', border: "none", outline: "none" },
    saveButton: { padding: '12px 0px', background: '#FF9800', color: 'white', border: 'none', cursor: 'pointer', width: "100%", borderRadius: "8px" },
    error: { color: 'red', marginTop: '8px' },
    locationText: {
        maxWidth: '82%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
    },
};

export default MyLocation;
